<!-- 各年度初次申领驾证数量 -->
<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from "echarts";
import resize from "@/components/chart/mixins/resize";
let chartVm = null;
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "vehiclesupervisorRightThird",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
      default: {},
    },
    unit: {
      type: String,
      default: "人",
    },
    max: {
      type: Number,
      default() {
        return 10;
      },
    },
    min: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      chart: null,
      timer: null,
      // 立体柱状图颜色
      colorArr: [
        ["rgba(7, 125, 68, ", "rgba(25, 218, 125, "],
        ["rgba(4, 93, 50, ", "rgba(3, 117, 62, "],
        ["rgba(125, 85, 6, ", "rgba(217, 152, 24, "],
        ["rgba(92, 62, 4, ", "rgba(117, 79, 4, "],
      ],
      options: {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0, 81, 28, 0.5)",
          position: function (point, params, dom, rect) {
            return [rect.x + rect.width / 2 - 10, rect.y - 36]; // 居中显示在柱顶上方
          },
          formatter(params) {
            let dom = "";
            [params].map((v) => {
              dom += `
              <div style="background: rgba(0, 81, 28, 0.5);border-radius: 4px;font-size:12px;color: #95FFBA;font-weight:400;line-height:1;">${
                v.value < 1 ? 0 : v.value
              }</div>`;
            });
            return `<div>${dom}</div>`;
          },
        },
        // legend: {
        //   top: '4px',
        //   icon: 'rect',
        //   itemWidth: 12,         // 图标宽度
        //   itemHeight: 4,         // 图标高度
        //   right: '16px',
        //   selectedMode: false,
        //   textStyle: {
        //     color: '#fff',
        //     fontFamily: 'Microsoft YaHei',
        //     fontSize: 12
        //   }
        // },
        grid: {
          right: 0,
          left: "10%",
          top: "22%",
          bottom: "20%",
        },
        xAxis: {
          type: "category",
          axisTick: {
            //y轴刻度线
            show: false,
          },
          offset: 8,
          axisLabel: {
            interval: 0,
            color: "#BABBBD",
            fontSize: 12,
          },
          axisLine: {
            show: false,
          },
          data: [],
        },
        yAxis: {
          name: `（${this.unit || "人"}）`,
          min: 0,
          max: 10,
          nameTextStyle: {
            color: "#BABBBD",
            fontSize: 12,
            align: "right",
            padding: [0, 12, -5, 0],
          },
          type: "value",
          axisLabel: {
            color: "#BABBBD",
            fontSize: 12,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#FFFFFF",
            },
            width: 5,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(88, 252, 146, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log("echarts.watch.val::", val);
        this.initChart();
      },
    },
  },
  mounted() {
    this.initChart();
    chartVm = this;
  },
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 500);
    });
  },
  created() {},
  // beforeDestroy() {
  //   if (!this.chart) {
  //     return;
  //   }
  //   this.chart.dispose();
  //   this.chart = null;
  // },
  methods: {
    setChartData() {
      this.options.yAxis.name = `（${this.unit || "人"}）`;
      let series = [];
      let that = this;
      if (this.chartData.nums && this.chartData.nums.length > 0) {
        // 为了实现立体效果，把两个柱子并在一起
        series.push({
          name: "leftBar",
          barMinHeight: 2,
          type: "bar",
          barGap: 0,
          barWidth: "10",
          label: {
            show: false,
            position: "insideLeft",
            formatter(v) {
              if (v.value) {
                return "";
              } else {
                return v.value;
              }
            },
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[0][1] + "1)",
                    },
                    {
                      offset: 1,
                      color: that.colorArr[0][0] + "1)",
                    },
                  ]
                );
              },
            },
            emphasis: {
              // 鼠标悬浮时的样式
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: that.colorArr[2][1] + "1)",
                  },
                  {
                    offset: 1,
                    color: that.colorArr[2][0] + "1)",
                  },
                ]
              ),
            },
          },
          data: this.chartData.nums,
          z: 5,
          zlevel: 10,
        });
        series.push({
          name: "rightBar",
          barMinHeight: 2,
          type: "bar",
          barWidth: "10",
          barGap: 0,
          label: {
            show: false,
            position: "insideLeft",
            formatter(v) {
              if (v.value) {
                return "";
              } else {
                return v.value;
              }
            },
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[1][1] + "1)",
                    },
                    {
                      offset: 1,
                      color: that.colorArr[1][0] + "1)",
                    },
                  ]
                );
              },
            },
            emphasis: {
              // 鼠标悬浮时的样式
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: that.colorArr[3][1] + "1)",
                  },
                  {
                    offset: 1,
                    color: that.colorArr[3][0] + "1)",
                  },
                ]
              ),
            },
          },
          data: this.chartData.nums,
          z: 5,
          zlevel: 10,
        });
        series.push({
          // 最下面菱形
          data: this.chartData.nums,
          type: "pictorialBar",
          symbol: "diamond",
          symbolSize: [20, 10],
          symbolPosition: "end",
          symbolOffset: [0, -5],
          itemStyle: {
            normal: {
              color: function (params) {
                return that.colorArr[0][1] + "1)";
              },
            },
            emphasis: {
              // 鼠标悬浮时的样式
              color: "rgba(255, 193, 69, 1)",
            },
          },
          z: 6,
          zlevel: 10,
        });

        this.options.xAxis.data = this.chartData.names;
        let seriesDataCopy = null;
        this.options.xAxis.data = this.chartData.names;
        this.options.yAxis.min = this.min;
        this.options.yAxis.max = this.max;
        this.options.series = series;
        this.chart.setOption(this.options, true);
      } else {
        this.options.xAxis.data = [];
        this.options.series = [];
        this.chart.setOption(this.options, true); // 设置为true的话，就是notMerge，不合并,false的话，就Merge，之前的东西还保留~
      }
    },
    initChart() {
      // if(this.chart) {
      //   this.chart.dispose()
      // }
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
      let _this = this;
      // 监听 hover 事件
      this.chart.on("mouseover", function (params) {
        const dataIndex = params.dataIndex;
        _this.chart.dispatchAction({
          type: "highlight",
          seriesIndex: [0, 1, 2],
          dataIndex: dataIndex,
        });
        _this.chart.dispatchAction({
          type: "showTip",
          seriesIndex: [0, 1, 2],
          dataIndex: dataIndex,
        });
      });
      // 监听移出事件
      this.chart.on("mouseout", function (params) {
        _this.chart.dispatchAction({
          type: "downplay",
          seriesIndex: [0, 1, 2],
          dataIndex: params.dataIndex,
        });
      });
    },
  },
};
</script>
